<template>
  <div class="wrapper" >
    <div class="wrapper-content">
      <div class="content">
        <div class="title">请输入卡背面激活码</div>
        <div class="input-wrapper">
          <cube-input
              @blur.native.capture="inputBlur()"
              v-model="vipCode"
              placeholder="卡密码不区分大小写"
              :clearable="true"
          ></cube-input>
        </div>
        <div class="active-wrapper clearfix">
          <div class="active-button" @click="activeCard">激活</div>
        </div>
      </div>

      <div class="img-wrapper">
        <img src="https://qiniuimage.warmdoctor.cn/WechatIMG4185.jpeg" alt="">
      </div>
      <div class="tips">您好！欢迎激活温暖医生视频卡，温暖医生将是您的私人医生，成为您的专属健康管家。            <br>请仔细阅读该视频卡激活后用卡规则：<br><span>1、请按预约时间上线视频，如错过预约时间会被视为爽约。</span><span> 2、视频卡使用当天不可连续预约占用同一位医生视频时间。</span><span>3、若临时需取消请至少提前2小时取消。</span><span>4、二次以上爽约或没按要求取消，视频卡将暂停使用1个月。</span></div>
    </div>
  </div>
</template>

<script>
import { activateProxyCard } from '@/api/yuyueApi'
export default {
  name: 'active',
  props: {},
  data() {
    return {
      vipCode: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    async activeCard () {
      if (!this.vipCode){
        return
      }
      const res = await activateProxyCard({pwd: this.vipCode})
      console.log(res)
      if (res.code == 9000200){
        this.toast = this.$createToast({
          time: 1500,
          txt: '激活成功跳转预约',
          type: 'txt'
        }).show()
        setTimeout(()=>{
          this.$router.push({
            path: '/doclist'
          })
        }, 1100)
      }else  {
        this.toast = this.$createToast({
          time: 1500,
          txt: res.message,
          type: 'txt'
        }).show()
      }

    },
    inputBlur () {
      window.scrollTo(0, document.body.scrollTop)
    }
  }
}
</script>

<style lang="stylus" scoped>

.wrapper {
  position: absolute;
  overflow: scroll;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.wrapper-content {
  padding 20px 0
}
.content {
  font-size 20px
  background white
  padding 10px
  margin-left 10px
  margin-right 10px
  border-radius 10px
  .title {
    font-size 14px
    color: #4a4a4a;
  }
  .input-wrapper {
    margin-top 10px
    border:1px solid #ccc
  }
}
.active-wrapper {
  width 100%
}
.active-button {
  font-size 14px
  text-align center
  color #4a4a4a
  background-color #ffee4f
  width 120px
  line-height 40px
  float right
  margin-right 20px
  margin-top 15px
  border-radius 5px
}

.img-wrapper{
  margin 10px 0
  &>img {
    display block
    margin 0 auto
    width 300px
    height 185px
    object-fit cover
    border-radius 10px
  }
}
.tips {
  margin 0 20px
  // margin-bottom 40px
  font-size 12px
  line-height 24PX
  color white
  &>span {
    display block
    padding-top 5px
  }
}

</style>
